import { styled } from 'styled-components'

export const RectangleIcon = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-radius: 2px;
`

export const PointIcon = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: currentColor;
`

// Example of additional annotation icons
export const LineIcon = styled.div`
  width: 16px;
  height: 16px;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: currentColor;
    top: 50%;
    left: 0;
    transform: translateY(-50%) rotate(45deg);
  }
`

export const PolygonIcon = styled.div`
  width: 16px;
  height: 16px;
  position: relative;
  clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
  background-color: currentColor;
` 